import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { ClosedSelect, DateRangePickerPro } from '@piplapps/pipl-ui';
import moment from 'moment';
import styles from './UsageFilters.module.less';
import { UsersSelectors } from '../../../Redux/modules/users/selectors';
import { UsageSelectors } from '../../../Redux/modules/usage/selectors';
import { UsageActions } from '../../../Redux/modules/usage/actions';
import { StatusFilterMapper } from '../../Users/constants';
import { AppSelectors } from '../../../Redux/modules/app/selectors';

const UsageFilters = (props) => {
  const [filter, setFilter] = useState({
    startDate: moment.utc().subtract(29, 'days').startOf('day'),
    endDate: moment().utc(),
  });
  const handleUserChange = (e) => {
    props.onFilterChange({ filter: 'user', value: e.target.value });
  };

  const handleStatusFilterChange = (id) => {
    props.onFilterChange({ filter: 'status', value: id });
  };

  const handleTeamsFilterChange = (id) => {
    props.onFilterChange({ filter: 'teams', value: id });
  };

  const handleTimeFilterChange = (timeRange) => {
    setFilter(timeRange);
    props.onFilterChange({
      filter: 'time',
      value: { startDate: timeRange.startDate.format('X'), endDate: timeRange.endDate.format('X') },
    });
    props.getUsageData({
      start_date: timeRange.startDate.format('X'),
      end_date:
        timeRange.endDate.isSame(moment(), 'd') || timeRange.endDate > moment()
          ? moment().utc().format('X')
          : timeRange.endDate.format('X'),
    });
  };

  const { teams, isTeamManagement } = props;

  const statusOptions = [
    { value: StatusFilterMapper.ALL, label: `View all` },
    { value: StatusFilterMapper.ASSIGNED, label: `Assigned` },
    {
      value: StatusFilterMapper.UNASSIGNED,
      label: `Not assigned`,
    },
    {
      value: StatusFilterMapper.REMOVED,
      label: `Removed`,
    },
  ];
  const teamsList = teams?.map((team) => {
    return {
      value: team.name,
      label: team.name,
    };
  });
  const missingOptions = [
    { value: 'all', label: 'All' },
    { value: 'unassigned', label: 'Unassigned' },
  ];
  const teamsOptions = missingOptions.concat(teamsList);

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.filterContainer}>
            <div>
              <DateRangePickerPro
                alwaysShowCalendars={false}
                changeDateFilter={handleTimeFilterChange}
                filter={filter}
              />
            </div>
            <div className={styles.selectWrapper}>
              <ClosedSelect
                options={statusOptions}
                name="statusFilter"
                id="statusFilter"
                setValue={(v) => v}
                onChange={(e) => handleStatusFilterChange(e)}
                label={gettext('SEARCH status')}
                isSearchable={false}
                value={statusOptions[0].value}
                icons
                grey
              />
            </div>
            {isTeamManagement && teams?.length > 0 ? (
              <div className={styles.selectWrapper}>
                <ClosedSelect
                  options={teamsOptions}
                  name="filter"
                  id="filter"
                  onChange={(e) => handleTeamsFilterChange(e)}
                  setValue={(v) => v}
                  value={teamsOptions[0].value}
                  label={gettext('Teams')}
                  isSearchable={false}
                  grey
                />
              </div>
            ) : null}
          </div>
          <div className={styles.searchBarContainer}>
            <input
              id="users-search-bar"
              className={styles.searchBar}
              type="text"
              placeholder={gettext('Find a user')}
              value={props.query}
              onChange={(e) => handleUserChange(e)}
            />
            <div className={styles.searchIcon} />
          </div>
        </div>
      </div>
    </>
  );
};

UsageFilters.propTypes = {
  query: PropTypes.string,
  onFilterChange: PropTypes.func,
  getUsageData: PropTypes.func,
  isTeamManagement: PropTypes.bool,
  teams: PropTypes.array,
  timeFilter: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    query: UsageSelectors.userFilterSelector(state),
    teams: UsersSelectors.teamsSelector(state),
    isTeamManagement: AppSelectors.isTeamManagementSelector(state),
    timeFilter: UsageSelectors.timeFilterSelector(state),
  };
};

const mapDispatchToProps = {
  onFilterChange: UsageActions.onFilterChange,
  getUsageData: UsageActions.fetchUsageData,
};

export default connect(mapStateToProps, mapDispatchToProps)(UsageFilters);
